/** @type {import('../types').ProgramConfig} */
export default {
  code: 'MMP_VMP',
  displayName: 'Microsoft & VMware Modernization',
  shortName: 'MMP/VMP',
  color: 'blue',
  // The three recommendations the agent can emit, from make_decision: a `clean`
  // run with every cell read becomes recommend_approval, a `clean` run holding a
  // not_checked cell is downgraded to needs_review, and `reject` becomes
  // recommend_rejection. No individual rule recommends approval (asserted in
  // ChronosAgentCoreAgents by test_no_rule_recommends_approval) — it is a
  // run-level conclusion, so it is a status a reviewer does see here.
  statusLabels: {
    recommend_approval: 'Recommend Approval',
    recommend_rejection: 'Recommend Rejection',
    needs_review: 'Needs Review',
  },
  sidebarItems: [],
  listColumns: [],

  // Reviewer-feedback panel + validation-summary card. `key` values are the
  // SOP domains, which is exactly what the agent rolls its 32 rule findings
  // up into: rules/summary.py::validation_groups is keyed on
  // sop.validation_taxonomy, so these keys are the keys of
  // approval_summary.validation_groups rather than a second vocabulary.
  // Ordered as the taxonomy declares them — the domains are peers, not a step
  // sequence, so they carry no step numbers (unlike MDF's SOP steps).
  //
  // Eight domains, not the taxonomy's ten: the four rules under `tagging` and
  // `duplicates` (TG-001/002/003, DUP-001) are all `reports_only`, so they are
  // absent from RULE_ORDER and validation_groups omits both domains rather than
  // report a group that judged nothing. They arrive here when their rules do.
  feedback: {
    enabled: true,
    validations: [
      { key: 'partner_eligibility',
        label: 'Partner Eligibility (required designation; the request is one of ours)',
        keywords: ['partner eligibility', 'partner_eligibility', 'designation', 'PE-001', 'PE-002'] },
      { key: 'workload',
        label: 'Workload (a licence this programme can retire; SOW agrees with the declared use case)',
        keywords: ['workload', 'licence', 'license', 'target state', 'sow', 'WL-001', 'WL-003', 'WL-006'] },
      { key: 'phase',
        label: 'Phase (which phase the request is for)',
        keywords: ['phase', 'migration phase', 'assess', 'mobilize', 'PH-001'] },
      { key: 'opportunity',
        label: 'Opportunity (valid ACE opportunity, stage, MMP-vs-VMP, ARR vs the Pricing Calculator)',
        keywords: ['opportunity', 'ace', 'stage', 'arr', 'pricing calculator', 'OS-001', 'OS-006'] },
      { key: 'timing',
        label: 'Timing (14 days between submission and start)',
        keywords: ['timing', '14 days', 'submission', 'start date', 'FR-001'] },
      { key: 'funding',
        label: 'Funding (ARR band, MVA flat amount, Project percentage, the $1,000,000 cap, never more than the SOW)',
        keywords: ['funding', 'band', 'cap', 'mva', 'project', 'amount', 'FA-001', 'FA-003', 'FA-004', 'FA-005'] },
      { key: 'documents',
        label: 'Documents (SOW, Pricing Calculator output, Funding Request Form, MVA output, VMC + RVtools)',
        keywords: ['documents', 'attachment', 'sow', 'funding request form', 'rvtools', 'AT-001', 'AT-004'] },
      { key: 'claim',
        label: 'Claim (partner sign-off template)',
        keywords: ['claim', 'sign-off', 'sign off', 'template', 'CL-001'] },
    ],
    // What the REVIEWER may recommend, which is a different list from
    // `statusLabels` above (what the AGENT can emit). A reviewer looking at a
    // needs_review recommendation must be able to approve, so
    // recommend_approval belongs here. Values must be in the
    // chronos-reviewer-feedback Lambda's VALID_DECISIONS.
    decisionOptions: [
      { value: 'recommend_approval',  label: 'Recommend Approval' },
      { value: 'recommend_rejection', label: 'Recommend Rejection' },
      { value: 'needs_review',        label: 'Needs Review' },
    ],
  },
};
